import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pt-2 pl-4" }
const _hoisted_2 = { style: {"color":"red"} }


export default /*@__PURE__*/_defineComponent({
  __name: 'FormRow',
  props: {
    title: {},
    text: {},
    required: { type: Boolean },
    windowInnerWidth: {},
    rowContentClass: { default: '' }
  },
  setup(__props: any) {

const props = __props


return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_component_v_row, { class: "text-form pl-4 pr-3 d-flex align-center" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, {
        cols: props.windowInnerWidth && props.windowInnerWidth > 800 ? 2 : 3
      }, {
        default: _withCtx(() => [
          _createElementVNode("h6", _hoisted_1, [
            _createTextVNode(_toDisplayString(props.title), 1),
            _withDirectives(_createElementVNode("span", _hoisted_2, "✴︎", 512), [
              [_vShow, props.required]
            ])
          ])
        ]),
        _: 1
      }, 8, ["cols"]),
      _createVNode(_component_v_col, {
        cols: props.windowInnerWidth && props.windowInnerWidth > 800 ? 10 : 9,
        class: _normalizeClass(props.rowContentClass),
        style: {"position":"relative"}
      }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["cols", "class"])
    ]),
    _: 3
  }))
}
}

})